export default "__VITE_ASSET__c00610f3__"